function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "BF335321-D19F-49F5-B577-52252F7D3EC2");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "In-App-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Checkout---Flat-69-Plan-(Single)-+-Paypal",
  transform: "translate(-128.000000, -474.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(128.000000, 390.000000)"
}, React.createElement("g", {
  id: "Group-11",
  transform: "translate(0.000000, 84.000000)"
}, React.createElement("g", {
  id: "download-(1)"
}, React.createElement("path", {
  d: "M0,2.40875 C0,1.07875 1.115,0 2.49,0 L47.51,0 C48.885,0 50,1.07875 50,2.40875 L50,27.59125 C50,28.92125 48.885,30 47.51,30 L2.49,30 C1.115,30 0,28.92125 0,27.59125 L0,2.40875 Z",
  id: "Shape",
  fill: "#21569A"
}), React.createElement("path", {
  d: "M24.495,9.85625 L21.8575,21.70375 L18.6625,21.70375 L21.3,9.85625 L24.4925,9.85625 L24.495,9.85625 Z M37.92375,17.50625 L39.6025,13.05625 L40.56875,17.50625 L37.925,17.50625 L37.92375,17.50625 Z M41.48625,21.70375 L44.43625,21.70375 L41.8575,9.85625 L39.1375,9.85625 C38.5225,9.85625 38.00625,10.19875 37.7775,10.725 L32.9875,21.70375 L36.34,21.70375 L37.005,19.935 L41.1,19.935 L41.4875,21.70375 L41.48625,21.70375 Z M33.1525,17.83625 C33.165,14.70875 28.6525,14.53625 28.68125,13.13625 C28.69125,12.71375 29.1125,12.26125 30.035,12.145 C30.49125,12.08875 31.75125,12.045 33.18125,12.67625 L33.74125,10.16375 C32.9725,9.89625 31.985,9.63875 30.75375,9.63875 C27.6,9.63875 25.37875,11.24875 25.3625,13.555 C25.3425,15.26 26.9475,16.21125 28.155,16.78 C29.4,17.36 29.8175,17.7325 29.81125,18.25125 C29.80375,19.04625 28.82,19.39875 27.90375,19.41125 C26.2975,19.43625 25.36625,18.995 24.625,18.66125 L24.0475,21.26125 C24.795,21.58875 26.1725,21.87375 27.5975,21.88875 C30.95,21.88875 33.14375,20.2975 33.15375,17.835 L33.1525,17.83625 Z M19.935,9.855 L14.7625,21.7025 L11.3875,21.7025 L8.845,12.25 C8.69125,11.6675 8.5575,11.45375 8.0875,11.2075 C7.31875,10.8075 6.05,10.4325 4.9375,10.2 L5.0125,9.85625 L10.44375,9.85625 C11.13625,9.85625 11.75875,10.29875 11.91625,11.06375 L13.26125,17.92125 L16.58,9.85875 L19.93375,9.85875 L19.935,9.855 Z",
  id: "Shape",
  fill: "#FFFFFF"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "50px",
    height: "30px",
    viewBox: "0 0 50 30",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/icon-visa.d906d322.svg";
export { SvgComponent as ReactComponent };